import React, { useState } from "react";
import { useSiteContent } from "@/lib/siteContent";

export const Testimonials = () => {
  const { content } = useSiteContent();
  const QUOTES = content.testimonials || [];
  const [i, setI] = useState(0);

  if (QUOTES.length === 0) return null;
  const safeIndex = Math.min(i, QUOTES.length - 1);
  const q = QUOTES[safeIndex];

  return (
    <section
      id="testimonials"
      className="py-24 lg:py-32 bg-[#0A2342] text-[#FDFBF7] relative overflow-hidden"
    >
      <div className="absolute -top-20 -right-20 w-[480px] h-[480px] rounded-full bg-[#CBA358]/10 blur-3xl" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
          {content.testimonials_eyebrow}
        </div>
        <h2 className="font-display text-4xl lg:text-5xl mt-4 leading-[1.05] text-balance max-w-3xl">
          {content.testimonials_headline}
        </h2>

        <div className="mt-14 relative">
          <div className="font-display text-[120px] leading-none text-[#CBA358]/30 absolute -top-12 -left-2">
            &ldquo;
          </div>
          <blockquote
            key={safeIndex}
            className="anim-fade-up font-display text-2xl sm:text-3xl lg:text-4xl leading-snug text-[#FDFBF7] italic text-pretty max-w-4xl"
          >
            {q.body}
          </blockquote>

          <div className="mt-10 flex flex-wrap items-center justify-between gap-6">
            <div>
              <div className="font-body uppercase tracking-[0.18em] text-sm font-semibold">
                {q.name}
              </div>
              {q.meta && (
                <div className="text-xs uppercase tracking-[0.2em] text-[#CBA358] mt-1">
                  {q.meta}
                </div>
              )}
            </div>

            <div className="flex items-center gap-3">
              {QUOTES.map((_, idx) => (
                <button
                  key={idx}
                  data-testid={`testimonial-dot-${idx}`}
                  onClick={() => setI(idx)}
                  aria-label={`Show testimonial ${idx + 1}`}
                  className={`h-px transition-all ${
                    safeIndex === idx
                      ? "w-12 bg-[#CBA358]"
                      : "w-6 bg-[#FDFBF7]/40 hover:bg-[#FDFBF7]"
                  }`}
                />
              ))}
              <button
                data-testid="testimonial-next"
                onClick={() => setI((safeIndex + 1) % QUOTES.length)}
                className="ml-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#CBA358] hover:text-white transition-colors"
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
